
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavyRainShowersDay as ObiLightningHeavyRainShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-rain-showers-day.js';
 
 
 

 
 export const ObiLightningHeavyRainShowersDay = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-rain-showers-day',
   elementClass: ObiLightningHeavyRainShowersDayElement,
   events: {
     
   }
  });
 
 